import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import { IOption } from "@faire/web--source/slate/Input/Dropdown";

export const BRAND_VALUES = (
  strictLocalize: StrictLocalizeFunction
): IOption[] => [
  {
    value: "Not on Amazon",
    label: strictLocalize({
      defaultMessage: "Not on Amazon",
      description: {
        text: "Brand that does not sell on Amazon's marketplace platform",
      },
    }),
  },
  {
    value: "Eco-Friendly",
    label: strictLocalize({
      defaultMessage: "Eco-Friendly",
      description: { text: "Brand that is eco-friendly" },
    }),
  },
  {
    value: "Small-batch",
    label: strictLocalize({
      defaultMessage: "Small-batch",
      description: { text: "Brand that makes products in small batches" },
    }),
  },
  {
    value: "Women Owned",
    label: strictLocalize({
      defaultMessage: "Women Owned",
      description: { text: "Brand that is women owned" },
    }),
  },
  {
    value: "Handmade",
    label: strictLocalize({
      defaultMessage: "Handmade",
      description: {
        text: "Brand that does not sell on Amazon's marketplace platform",
      },
    }),
  },
  {
    value: "BIPOC Owned",
    label: strictLocalize({
      defaultMessage: "BIPOC Owned",
      description: {
        text: "Brand that is owned by a Black, Indigenous, or Person Of Color (BIPOC)",
      },
    }),
  },
  {
    value: "Organic",
    label: strictLocalize({
      defaultMessage: "Organic",
      description: { text: "Brand that considers itself Organic" },
    }),
  },
];
